import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchMetricsModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchMetricsModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchMetricsModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchMetricsModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchMetricsModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
